import { QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { RouterProvider } from "react-router";
import { Toaster } from "sonner";

import { createQueryClient } from "@/app/queryClient";
import { router } from "@/app/router";
import { SessionProvider } from "@/app/session/SessionProvider";
import { LocaleProvider } from "@/shared/i18n/LocaleProvider";

export function App() {
  const [queryClient] = useState(createQueryClient);
  return (
    <LocaleProvider>
      <QueryClientProvider client={queryClient}>
        <SessionProvider>
          <RouterProvider router={router} />
          <Toaster position="top-center" closeButton theme="light" />
        </SessionProvider>
      </QueryClientProvider>
    </LocaleProvider>
  );
}
